import { Component, OnInit, Input, Output, EventEmitter, QueryList, ViewChildren } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { NgbSlideEvent, NgbCarousel } from '@ng-bootstrap/ng-bootstrap/carousel/carousel';

import Social from 'entity/Social';
import SocialTheme from 'entity/SocialTheme';
import Paging from 'rest/Paging';

import { SocialThemeTab } from '../modal-create-social/modal-create-social.types';
import { VideoChatService } from '../services/videochat.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-social-theme-carousel',
  templateUrl: './social-theme-carousel.component.html',
  styleUrls: ['./social-theme-carousel.component.scss'],
  standalone: false,
})
export class SocialThemeCarouselComponent implements OnInit {
  @Input() public social?: Social;
  @Output() public slideChanged = new EventEmitter<SocialTheme>();
  @ViewChildren('themeCarousel') public themeCarousel?: QueryList<NgbCarousel>;
  public themeTabs: SocialThemeTab[] = [];
  public currentTabIndex = 0;
  public themeOptions: Record<string, SocialTheme> = {};

  public constructor(
    private videoChatService: VideoChatService,
    private domSanitizer: DomSanitizer,
  ) {}

  public async ngOnInit(): Promise<void> {
    await this.getThemeCategories();
  }

  private async getThemeCategories(): Promise<void> {
    const themeCategories = await this.videoChatService.getThemeCategories();
    let index = 0;
    for (const themeCategory of themeCategories) {
      const themes = await this.videoChatService.getThemesForCategory(
        themeCategory.socialThemeCategoryId ?? '',
        new Paging(0, 100),
      );
      this.themeTabs.push({ themeCategory, themes });
      themes.forEach((t) => (this.themeOptions[t.socialThemeId ?? ''] = t));
      const currentTheme = themes.find((t) => t.socialThemeId === this.social?.themeId);
      if (currentTheme) {
        this.currentTabIndex = index;
      }
      index++;
    }
  }

  public safeStyleAttribute(v?: string): SafeStyle {
    return v ? this.domSanitizer.bypassSecurityTrustStyle(v) : 'none';
  }

  // ngb-carousel slide listener
  public onSlide(event: NgbSlideEvent): void {
    if (event && event.current) {
      const newThemeId = event.current.replace('id_', '');
      const theme = this.themeOptions[newThemeId];
      if (theme) {
        this.slideChanged.emit(theme);
      }
    }
  }

  public tabChanged(e: number): void {
    if (!this.themeCarousel) {
      return;
    }
    const carousel = this.themeCarousel.toArray()[e];
    const newThemeId = carousel.activeId.replace('id_', '');
    const theme = this.themeOptions[newThemeId];
    if (theme) {
      this.slideChanged.emit(theme);
    }
  }
}
